import { render } from "./pwMgmt.vue?vue&type=template&id=a7c4d5a8"
import script from "./pwMgmt.vue?vue&type=script&lang=js"
export * from "./pwMgmt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__